jQuery(document).ready(function($) {
    $('.like-icon').on('click', function(event) {
        event.preventDefault();
        var $this = $(this);
        var commentId = $this.data('comment-id');
        var $likeCount = $this.find('.likes-count');

        // Перевірка, чи користувач залогінений
        if (!$('body').hasClass('logged-in')) {
            // Якщо користувач не залогінений, відкриваємо модальне вікно для входу
            $('#modal-login').addClass('open');
            return; // Припиняємо виконання подальшого коду
        }

        // Виконання AJAX запиту, якщо користувач залогінений
        $.ajax({
            type: 'POST',
            url: ajax_like.ajax_url,
            data: {
                action: 'handle_like',
                comment_id: commentId
            },
            dataType: 'json',
            success: function(response) {
                if (response.success) {
                    $likeCount.text(response.data.new_likes_count + ' Likes');
                    $this.toggleClass('user-liked'); // Переключення класу в залежності від стану лайка
                } else {
                    alert('Error: ' + response.data.error);
                }
            },
        });
    });
});

